"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditorialPage = void 0;
var _mui = require("@ori-ui/mui");
var _editorialComponents = require("@ori/editorial-components");
var _featureToggles = require("@ori/feature-toggles");
var _olapicLib = require("@ori/olapic-lib");
var _presentationHooks = require("@ori/presentation-hooks");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _ErrorBoundary = require("../../containers/ErrorBoundary");
var _useTranslations = require("../../hooks/useTranslations");
var _utils = require("../../utils");
var _createBannerLayout = require("../../utils/createBannerLayout");
var _BenefitsLayout = require("../BenefitsLayout");
var _FaqLayout = require("../FaqLayout");
var _FiftyFiftyLayout = require("../FiftyFiftyLayout");
var _LinkListLayout = require("../LinkListLayout");
var _LinksCarouselLayout = require("../LinksCarouselLayout");
var _TableLayout = require("../TableLayout");
var _TestimonialsLayout = require("../TestimonialsLayout");
var _standalone = require("../standalone");
var _styles = require("../styles");
var _EditorialPageSkeleton = require("./EditorialPageSkeleton");
var _Errors = require("./Errors");
var _constants2 = require("./constants");
var _editorialPageClasses = require("./editorialPageClasses");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const EditorialPage = (param)=>{
    let { breadcrumbs, data, productBoxConfiguration, className, preview, renderOnMyPages } = param;
    const { translations } = (0, _useTranslations.useTranslations)();
    const { getTestId } = (0, _testidGenerator.default)();
    const { isFeatureEnabled } = (0, _featureToggles.useFeatureToggles)();
    const { customerTypeId } = (0, _presentationHttp.useUserSegmentationData)();
    const debug = (0, _utils.getEditorialDebug)();
    const application = (0, _presentationHooks.useDeepDecode)(data === null || data === void 0 ? void 0 : data.application);
    const { editorialPage, editorialLandingPage } = application !== null && application !== void 0 ? application : {};
    // istanbul ignore next @preserve -- reachable only in preview mode
    if (!editorialPage) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_EditorialPageSkeleton.EditorialPageSkeleton, {
            className: className
        });
    }
    const relatedArticles = editorialPage.contentItems.filter((module)=>module.__typename === 'EditorialPage');
    const topBanner = editorialPage.contentItems.find((module)=>module.__typename === 'EditorialHeader');
    const layouts = editorialPage.contentItems.map((module, modulePosition)=>{
        switch(module.__typename){
            case 'EditorialOlapic':
                var _module_product;
                var _module_type, _module_categoryId;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.__typename,
                    modulePosition: modulePosition,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_standalone.Olapic, {
                            type: (_module_type = module.type) !== null && _module_type !== void 0 ? _module_type : _olapicLib.OlapicTypeEnum.FrontPage,
                            categoryId: (_module_categoryId = module.categoryId) !== null && _module_categoryId !== void 0 ? _module_categoryId : undefined,
                            productCode: (_module_product = module.product) === null || _module_product === void 0 ? void 0 : _module_product.productCode,
                            isMrpStatementEnabled: productBoxConfiguration.isMrpStatementEnabled,
                            isRatingsAndReviewsEnabled: productBoxConfiguration.isRatingsAndReviewsEnabled,
                            isSubscriptionEnabled: isFeatureEnabled(_constants.EditorialPageFeature.PersonalSubscriptions) && !(0, _presentationUtils.isEmployee)(customerTypeId)
                        }, "olapic")
                    })
                }, module.id);
            case 'EditorialTestimonialCarousel':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.__typename,
                    modulePosition: modulePosition,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.FullWidthEditorialsModule, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TestimonialsLayout.TestimonialsLayout, {
                            data: module,
                            debug: debug,
                            modulePosition: modulePosition
                        })
                    })
                }, module.id);
            case 'EditorialFrequentlyAskedQuestions':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.__typename,
                    modulePosition: modulePosition,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                        paddingOnMobile: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FaqLayout.FaqLayout, {
                            data: module,
                            debug: debug,
                            modulePosition: modulePosition
                        })
                    })
                }, module.id);
            case 'EditorialFiftyBanner':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.__typename,
                    modulePosition: modulePosition,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.FullWidthEditorialsModule, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FiftyFiftyLayout.FiftyFiftyLayout, {
                            debug: debug,
                            modulePosition: modulePosition,
                            banner: module
                        })
                    })
                }, module.id);
            case 'EditorialLinkList':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.__typename,
                    modulePosition: modulePosition,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                        paddingOnMobile: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_LinkListLayout.LinkListLayout, {
                            data: module,
                            debug: debug,
                            modulePosition: modulePosition
                        })
                    })
                });
            case 'EditorialLinkCarousel':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.__typename,
                    modulePosition: modulePosition,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                        paddingOnMobile: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_LinksCarouselLayout.LinksCarouselLayout, {
                            data: module,
                            debug: debug,
                            modulePosition: modulePosition,
                            renderOnMyPages: renderOnMyPages
                        })
                    })
                });
            case 'EditorialBenefits':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.__typename,
                    modulePosition: modulePosition,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                        paddingOnMobile: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BenefitsLayout.BenefitsLayout, {
                            renderOnMyPages: renderOnMyPages,
                            data: module,
                            debug: debug,
                            modulePosition: modulePosition
                        })
                    })
                });
            case 'EditorialProductBoxCarousel':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.__typename,
                    modulePosition: modulePosition,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_standalone.Products, {
                            debug: debug,
                            modulePosition: modulePosition,
                            hideRating: !productBoxConfiguration.isRatingsAndReviewsEnabled,
                            hideSubscription: !isFeatureEnabled(_constants.EditorialPageFeature.PersonalSubscriptions) || (0, _presentationUtils.isEmployee)(customerTypeId),
                            mrpStatementEnabled: productBoxConfiguration.isMrpStatementEnabled,
                            headline: module.headline,
                            productCodes: (0, _utils.getProductCodes)(module.products)
                        }, "product-carousel")
                    })
                }, "".concat(module.__typename, "-").concat(modulePosition));
            case 'TableModule':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.__typename,
                    modulePosition: modulePosition,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                        paddingOnMobile: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TableLayout.TableLayout, {
                            data: module,
                            debug: debug,
                            modulePosition: modulePosition
                        })
                    })
                });
            case 'EditorialBanner':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.layout,
                    modulePosition: modulePosition,
                    children: (0, _createBannerLayout.createBannerLayout)({
                        banner: module,
                        debug,
                        modulePosition,
                        renderOnMyPages
                    })
                }, module.id);
            case 'EditorialPage':
                return null;
            default:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                    debug: debug,
                    module: module.__typename,
                    modulePosition: modulePosition,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Errors.Errors.UnknownTypename, {
                        debug: debug,
                        modulePosition: modulePosition,
                        layout: module.__typename
                    })
                }, "unknownTypename-".concat(modulePosition));
        }
    });
    const articles = (0, _editorialComponents.mapEditorialCarousel)({
        slides: relatedArticles
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            topBanner ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
                debug: debug,
                module: topBanner.__typename,
                modulePosition: 0,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_standalone.HeaderArea, {
                    breadcrumbs: breadcrumbs,
                    debug: debug,
                    header: topBanner,
                    modulePosition: 0
                }, "header-area")
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Root, {
                "data-testid": getTestId(_constants2.EDITORIAL_PAGE),
                className: className,
                children: [
                    preview ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Alert, {
                        color: "success",
                        severity: "info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                            children: "PREVIEW MODE"
                        })
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.Inner, {
                        className: _editorialPageClasses.editorialPageClasses.inner,
                        children: layouts
                    }),
                    articles.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.EditorialCarouselRoot, {
                        className: _editorialPageClasses.editorialPageClasses.editorialCarouselRoot,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_editorialComponents.EditorialCarouselSection, {
                            data: articles,
                            labelRead: translations.readNow,
                            title: translations.inspirationCorner,
                            id: "editorial-page-related-articles-carousel"
                        })
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.CategoriesSection, {
                        categories: editorialLandingPage === null || editorialLandingPage === void 0 ? void 0 : editorialLandingPage.themeItems,
                        title: translations.otherCategories,
                        viewButtonText: translations.view,
                        className: _editorialPageClasses.editorialPageClasses.categoriesSection
                    })
                ]
            })
        ]
    });
};
exports.EditorialPage = EditorialPage;
